import ReactTooltip from 'react-tooltip';
import Text from '../../../atoms/Text';
import Image from '../../../atoms/Image';
import Checkbox from '../../../molecules/Checkbox';
import question_in_circle from '../../../assets/images/question_in_circle.svg';

const SendTokens = ({ sendTokens, toggleSendTokens }: any) => {
  return (
    <div className='row send_tokens'>
      <div className='row send_tokens__title'>
        <Text size={12}>Send tokens to proxy</Text>

        <div
          className='send_tokens__title__info'
          data-for='send-tokens-tooltip'
          data-tip="Don't transfer tokens<br />when creating a limit order"
        >
          <Image src={question_in_circle} size='s' />
        </div>
      </div>
      <Checkbox checked={sendTokens} setChecked={toggleSendTokens} />

      <ReactTooltip
        id='send-tokens-tooltip'
        type='light'
        place='bottom'
        effect='solid'
        className='text_tooltip'
        multiline={true}
      />
    </div>
  );
};

export default SendTokens;
